// src/pages/Dashboard/Admin/DetailsAdherents/components/GroupsCategoriesPanel.jsx

import React from "react";
import DashboardDataTable from "./DashboardDataTable";
import { getGroupsFromAdherent } from "../utils/adherentDashboardUtils";

export default function GroupsCategoriesPanel({
  adherent,
  ageCategory,
  weightCategory,
}) {
  const groups = getGroupsFromAdherent(adherent);

  return (
    <div className="space-y-4">
      <div className="grid gap-3 sm:grid-cols-3">
        <div className="rounded-2xl border border-indigo-200 bg-indigo-50 p-4 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em]">
            Groupes
          </p>
          <p className="mt-1 text-xl font-semibold text-slate-950 dark:text-white">
            {groups.length}
          </p>
        </div>

        <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em]">
            Catégorie âge
          </p>
          <p className="mt-1 text-xl font-semibold text-slate-950 dark:text-white">
            {ageCategory}
          </p>
        </div>

        <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em]">
            Catégorie poids
          </p>
          <p className="mt-1 text-xl font-semibold text-slate-950 dark:text-white">
            {weightCategory}
          </p>
        </div>
      </div>

      <DashboardDataTable
        minWidth="760px"
        columns={[
          { key: "nom", label: "Groupe" },
          {
            key: "dojo",
            label: "Dojo",
            render: (row) => row?.Dojo?.dojo_nom || row?.dojo_nom || "—",
          },
          {
            key: "id",
            label: "ID",
            render: (row) => `#${row.id}`,
          },
        ]}
        rows={groups}
        emptyMessage="Aucun groupe lié à cet adhérent."
      />
    </div>
  );
}